define(function(require, exports, module) {
    'use strict';

    const $ = require('j');
    const i18n = require('i18n');
    const _ = require('underscore');
    const DateMixin = require('portlets/registration/mixins/date.mixin');

    module.exports = _.extend(DateMixin, {

        additionalEvents: _.extend(DateMixin.additionalEvents, {
            'change #month': 'handleMonthChange',
            'change .fn-generic-datepicker .field_name_month select': 'handleGenericMonthChange',
        }),

        handleMonthChange: function(event) {
            this.handleDateChange(event);
            this.setMonthAbbreviation(event);
        },

        handleGenericMonthChange: function(event) {
            this.handleGenericDateChange(event);
            this.setMonthAbbreviation(event);
        },

        setMonthAbbreviation: function(event) {
            const { value } = event.target;
            const monthDisplayEl = $(event.target).parent().find('.js-select__display');

            if (monthDisplayEl) {
                monthDisplayEl[0].textContent = i18n.t(`playtech.mobile.system.month.${value}.abbr`);
            }
        }
    });
});
